const $ = jQuery.noConflict();

const ctePrograms = () => {
    const block = $('.block-cte-programs');

    if (!block.length) {
        return;
    }

    const link = block.find('.block-cte-programs__program-link');
    const imagesWrapper = block.find('.block-cte-programs__programs-images');
    const image = block.find('.block-cte-programs__program-image');

    let timeout;
    const timeoutFunction = () => {
        timeout = window.setTimeout( () => {
            imagesWrapper.addClass('hide-default-image');

            setTimeout(() => {
                imagesWrapper.removeClass('switch-out');

                setTimeout(() => {
                    imagesWrapper.removeClass('disabled');
                }, 600);
            }, 100);
        }, 600);
    }

    const setLinkActive = (e) => {
        const currentLink = $(e.currentTarget);
        const currentImage = image.filter((i, item) => $(item).attr('data-program') === currentLink.attr('data-program'));

        if ( !currentLink.hasClass('active') ) {
            e.preventDefault();
        }

        link.not(currentLink).removeClass('active content-visible').find('.block-cte-programs__program-link-desc').stop().slideUp(600);
        currentLink.addClass('active').find('.block-cte-programs__program-link-desc').stop().slideDown(600);
        setTimeout(() => {
            currentLink.addClass('content-visible');
        }, 100);

        if ( !imagesWrapper.hasClass('switch-out') ) {
            imagesWrapper.addClass('active switch-out disabled');
            timeoutFunction();

        } else {
            clearTimeout( timeout );
            timeoutFunction();
        }

        image.addClass('switch-out');
        setTimeout(() => {
            image.removeClass('active switch-out').addClass('switch-in');
            currentImage.addClass('active');

            setTimeout(() => {
                image.removeClass('switch-in');
            }, 100);
        }, 600);
    }

    if ( 'ontouchstart' in window ) {
        link.on( 'click', setLinkActive);
    } else {
        link.on( 'mouseenter', setLinkActive);
    }
}

export { ctePrograms };
